<template>
  <div class="container">
    <header-app :title="$t('Hotel')" class="header-brand" to="province" />






    <div class="d-flex justify-content-center " v-if="loading == false & !hotel.id ">  
        <div class="text-center mt-5" style="padding-top: 100px">
          <img src="@/assets/icon/icon01.svg" width="100"  />
          <h6 class="mt-3">{{ $t("Hotel is not found!") }}</h6>
          <p> {{ $t('we are having another hotel!')}}</p>
          <button class="btn btn-brand mt-5" @click="$router.push('/')">
            {{ $t('Get Other')}}
          </button>
        </div> 
    </div>

    <wrap v-else>
      <base-slider v-if="hotel.id"
        :title="hotel.title"
        :images="hotel.images || []"
      ></base-slider>
 

      <div class="wrap_list_action">
        <!-- restaurant -->
        <template v-if="hotel.restaurants.length > 0">
          <div class="header">
            <img src="@/assets/res.svg" alt="" width="28" />
            {{ $t("Restaurant") }}
          </div>
          <div class="row">
            <div
              v-for="(restaurant, index) in hotel.restaurants || []"
              :key="index"
              class="col-lg-4 col-md-6 col-sm-12 col-xs-12"
            >
              <location-card
                :title="restaurant.title"
                :image="restaurant.image"
                type="restaurant"
                :location_id="restaurant.location_id"
                :description="restaurant.location_name"
                :isOpen="restaurant.is_open"
                :address="restaurant.address"
                @click.native="openRestaurant(restaurant)"
              />
            </div>
          </div>
        </template>

      

        <!-- end restaurant -->

        <!-- shop -->
        <template v-if="hotel.shops.length > 0">
          <div class="header">
            <img src="@/assets/shop.svg" alt="" width="25" /> {{ $t("Shop") }}
          </div>
          <div class="row">
            <div
              v-for="(shop, index) in hotel.shops || []"
              :key="index"
              class="col-lg-4 col-md-6 col-sm-12 col-xs-12"
            >
              <location-card
                :title="shop.title"
                :image="shop.image"
                type="shop"
                :location_id="shop.location_id"
                :description="shop.location_name"
                :isOpen="shop.is_open"
              />
            </div>
          </div>
        </template>
        <!-- end shop -->

        <!-- spa -->
        <template v-if="hotel.spas.length > 0">
          <div class="header">
            <img src="@/assets/spa.svg" alt="" width="25" /> {{ $t("Spa") }}
          </div>
          <div class="row">
            <div
              v-for="(spa, index) in hotel.spas || []"
              :key="index"
              class="col-lg-4 col-md-6 col-sm-12 col-xs-12"
            >
              <location-card
                :title="spa.title"
                :image="spa.image"
                type="spa"
                :location_id="spa.location_id"
                :description="spa.location_name"
                :isOpen="spa.is_open"
              />
            </div>
          </div>
        </template>
        <!-- end spa -->


      <div class="row" v-if="loading">
          <loading-location />
        </div>
        <template
          v-if="
            hotel.restaurants.length + hotel.spas.length + hotel.shops.length == 0  && loading == false
          "
        >
          <div class="m-5 text-center">
            <div class="image mb-3">
              <img src="@/assets/menu.svg" alt="" width="50" />
            </div>
            {{ $t("no restaurant available!") }}
          </div>
        </template>
      </div>
    </wrap>
   
  </div>
</template>  
<style lang="css">
</style>

<script> 
import store from "@/store";
export default {
  layout: "Hotel",
  metaInfo: {
    title: "DiscoverLao Ordering",
  },
  data: () => ({}),
  computed: {
    hotel() {
      return store.getters["location/hotel"];
    },
    loading() {
      return store.getters["location/loading_hotel"];
    },
  },
  mounted() {
    this.getHotel();
  },
  methods: {
    async getHotel() {
      var slug = this.$route.params.slug;
      await store.dispatch("location/getHotel", slug);
    },
    async openRestaurant(restaurant) {
      if (restaurant.is_open === true)
        this.$router.push({ name: "detail", params: { id: restaurant.slug } });
    },
  },
};
</script>